/** Type Predicate: check if a string or number is a valid enum value and narrow the type accordingly. Be wary of reverse
 * mappings for integer enums.
 */
export default function enumIncludes<TEnum extends {[key: string]: string | number}>(
  enumObj: TEnum,
  value: string | number | null | undefined
): value is TEnum[keyof TEnum] {
  if (value == null) {
    return false;
  }
  return Object.values(enumObj).includes(value);
}

/** Check if a string or number is an enum value and then type-safely return the enum value.
 *
 * If it's not a value of the enum, return undefined.
 */
export function getEnumValue<TEnum extends {[key: string]: string | number}>(
  enumObj: TEnum,
  value: string | number
): TEnum[keyof TEnum] | undefined {
  if (enumIncludes(enumObj, value)) {
    return value;
  }
  return undefined;
}
